import React, { useState } from 'react';
import Header from './Header';
import RevendaConsultasMobtefPage from './RevendaConsultasMobtefPage';
import RevendaConsultasEmpresasPage from './RevendaConsultasEmpresasPage';

function RevendaConsultasPage({ usuario, empresaSelecionada, handleVoltar, handleSair, onSelecionarConsulta }) {
  const [abrirMobtef, setAbrirMobtef] = useState(false);
  const [abrirEmpresas, setAbrirEmpresas] = useState(false);

  const cardsConsultas = [
    {
      nome: 'MobTEF',
      key: 'mobtef',
      icon: (
        <svg className="w-8 h-8 mb-2 text-yellow-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
        </svg>
      ),
      onClick: () => setAbrirMobtef(true)
    },
    {
      nome: 'Empresas',
      key: 'empresas',
      icon: (
        <svg className="w-8 h-8 mb-2 text-green-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a4 4 0 00-3-3.87M9 20H4v-2a4 4 0 013-3.87m9-4a4 4 0 11-8 0 4 4 0 018 0zm6 4v2a2 2 0 01-2 2H5a2 2 0 01-2-2v-2a6 6 0 0112 0z" />
        </svg>
      ),
      onClick: () => setAbrirEmpresas(true)
    }
  ];

  if (abrirMobtef) {
    return (
      <RevendaConsultasMobtefPage
        usuario={usuario}
        empresaSelecionada={empresaSelecionada}
        handleVoltar={() => setAbrirMobtef(false)}
        handleSair={handleSair}
      />
    );
  }

  if (abrirEmpresas) {
    return (
      <RevendaConsultasEmpresasPage
        usuario={usuario}
        empresaSelecionada={empresaSelecionada}
        handleVoltar={() => setAbrirEmpresas(false)}
        handleSair={handleSair}
      />
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-blue-300">
      <Header
        usuario={usuario}
        empresa={empresaSelecionada}
        onVoltar={handleVoltar}
        onSair={handleSair}
      />
      <div className="flex flex-col items-center justify-center mt-16">
        <div className="bg-white p-10 rounded-2xl shadow-2xl w-full max-w-2xl border border-blue-100 flex flex-col items-center">
          <h2 className="text-2xl font-bold text-blue-700 mb-8">Consultas</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 w-full">
            {cardsConsultas.map(card => (
              <div
                key={card.key}
                className="bg-blue-50 rounded-lg shadow-md flex flex-col items-center justify-center p-6 cursor-pointer hover:bg-blue-100 transition border border-blue-300"
                onClick={card.onClick}
              >
                {card.icon}
                <span className="text-lg font-semibold text-blue-800">{card.nome}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default RevendaConsultasPage; 